<div class="row">
    <div class="col" *ngFor="let emp of searchCustomerTeamList" style="padding-right:10px;">
        <label class="fw-bold">{{emp.customerTeamTypeAbbreviation}}: </label>
        <span>{{emp.employeeName}}</span>
    </div>
</div>
